import {createApp} from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router/index.js';
import axios from 'axios'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import MetaInfo from 'vue-meta-info';

const app = createApp(App)

app.use(ViewUIPlus)
    .use(router).use(MetaInfo)
    .provide('$axios', axios)
    .mount('#app')